/* eslint-disable no-prototype-builtins */
import React, {
  useState, Fragment, useEffect,
} from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { CountryCodes } from '@Apis/constants';
import {
  Table, Popconfirm, Modal, Drawer, notification, Tooltip,
} from 'antd';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import RfqActions from '@Actions/purchase/rfq/rfqActions';
import H3FormInput from '@Uilib/h3FormInput';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import acceptBid from '@Images/accept-bid.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faSquareArrowUpRight } from '@fortawesome/free-solid-svg-icons';
import CounterVendorOfferForm from './CounterVendorOfferForm';
import PastNegotiations from './PastNegotiations';
import './style.scss';

const Participants = ({
  user, selectedRfq, loading, history, callback, negotiationActionLoading, negotiationAction, revokeCounterLoading, addCounterNegotiationLoading, acceptRfqLoading, MONEY,
}) => {
  const [showCounterOfferDrawer, setShowCounterOfferDrawer] = useState(false);
  const [selectedParticipant, setSelectedParticipant] = useState('');
  const [rfqParticipant, setRfqParticipant] = useState('');
  const [openPastNegotiationModal, setOpenPastNegotiationModal] = useState(false);

  const data = selectedRfq?.group_by_products_comparator;

  const columnKeys = Object.keys(data?.[0])?.filter((i) => i !== 'Other Charges');

  const renderOtherCharges = (otherCharges) => otherCharges.map((otherCharge, i) => (
    <div key={i} style={{ display: 'flex', justifyContent: 'center' }}>
      {`${otherCharge?.charge_name} - ${otherCharge?.value}`}
    </div>
  ));

  const getVendorOfferRecordData = (record, key) => {
    if (record[key]?.hasOwnProperty('is_product_participant_negotiation')) {
      return <div style={{ display: 'flex', justifyContent: 'center', width: '120px' }}>{record[key]?.price ? MONEY(record[key].price) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_total || 0)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_taxes_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_tax_total || 0)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_other_charges_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{record[key]?.other_charges?.length ? renderOtherCharges(record[key]?.other_charges) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_grand_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_grand_total)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_negotiation_decision_column')) {
      return (
        <Fragment>
          {(record[key]?.negotiation_status === 'PRICE_SUBMITTED') && (
            <div className="participants-negotiation__wrapper">
              <div className="participants-negotiation__footer-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
                <Fragment>
                  <div>
                    <H3Button
                      text="Counter Offer"
                      buttonType={defaultButtonTypes.BLUE_BORDERED}
                      onClick={() => {
                        if (record[key]?.negotiation_status === 'PRICE_SUBMITTED') {
                          setSelectedParticipant(record[key]);
                          setShowCounterOfferDrawer(true);
                        }
                      }}
                      customClass="participant-bid-button-left"
                      disabled={addCounterNegotiationLoading}
                    />
                  </div>
                </Fragment>
              </div>
            </div>
          )}
        </Fragment>
      );
    }

    return null;
  };

  const getCounterOfferRecordData = (record, key) => {
    if (record[key]?.hasOwnProperty('product_sku_name')) {
      return (
        <div style={{ width: '120px' }}>
          <Link to={`/inventory/product/view/${record[key]?.product_sku_info?.product_sku_id}`} target="_blank">
            {`#${record[key]?.product_sku_info?.internal_sku_code}`}
          </Link>
          <H3Text text={`${record[key]?.product_sku_info?.ref_product_code ? `${record[key]?.product_sku_info?.ref_product_code} - ` : ''}${record[key]?.product_sku_info?.product_sku_name}`?.trim()} className="" />
        </div>
      );
    }

    if (record[key]?.hasOwnProperty('is_product_participant_negotiation')) {
      return <div style={{ display: 'flex', justifyContent: 'center', width: '120px' }}>{Number(record?.[key]?.counter_price) > 0 ? MONEY(record[key]?.counter_price) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_counter_total || 0)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_taxes_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{Number(record[key]?.negotiation_tax_counter_total) > 0 ? MONEY(record[key]?.negotiation_tax_counter_total) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_other_charges_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{record[key]?.other_charges?.length ? renderOtherCharges(record[key]?.other_charges) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_grand_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{Number(record[key]?.negotiation_grand_counter_total) > 0 ? MONEY(record[key]?.negotiation_grand_counter_total) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_negotiation_decision_column')) {
      return (
        <Fragment>
          <div className="participants-negotiation__wrapper">
            <div className="participants-negotiation__footer-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
              <Fragment>
                {record[key]?.negotiation_status === 'COUNTERED' && (
                  <div>
                    <Popconfirm
                      placement="topRight"
                      title="Are you sure you want to revoke this offer?"
                      onConfirm={() => negotiationAction('revokeCounter', { negotiation_id: record[key]?.negotiation_id }, () => {
                        callback();
                      })}
                      okText="Yes"
                      cancelText="No"
                    >
                      <div className={`participant-bid-button-middle ${(acceptRfqLoading) && 'disabled'}`}>Revoke Offer</div>
                    </Popconfirm>
                  </div>
                )}
                {(record[key]?.negotiation_status === 'PRICE_SUBMITTED' || record[key]?.negotiation_status === 'COUNTER_ACCEPTED') && !(record[key]?.rfq_status === 'ACCEPTED') && (
                  <div>
                    <Popconfirm
                      placement="topRight"
                      title="Are you sure you want to accept this offer?"
                      onConfirm={() => {
                        if (record[key]?.rfq_status !== 'ACCEPTED') {
                          negotiationAction('acceptRfq', { negotiation_id: record[key]?.negotiation_id }, () => {
                            callback();
                          });
                        } else {
                          notification.error({
                            message: 'The Request for Quotation (RFQ) has already been acknowledged and accepted.',
                            placement: 'top',
                            duration: 4,
                          });
                        }
                      }}
                      okText="Yes"
                      cancelText="No"
                    >
                      <div className="participant-bid-button-middle">Shortlist</div>
                    </Popconfirm>
                  </div>
                )}
                {(record[key]?.rfq_status === 'ACCEPTED') && (
                  <div>
                    <div className="participant-bid-button-shortlisted">
                      <FontAwesomeIcon icon={faCheckCircle} />
                      &nbsp;
                      Shortlisted
                    </div>
                  </div>
                )}
              </Fragment>
            </div>
          </div>
        </Fragment>
      );
    }
    return null;
  };

  const getConfirmedOfferRecordData = (record, key) => {
    if (record[key]?.hasOwnProperty('product_sku_name')) {
      return (
        <div style={{ width: '200px' }}>
          <Link to={`/inventory/product/view/${record[key]?.product_sku_info?.product_sku_id}`} target="_blank">
            {`#${record[key]?.product_sku_info?.internal_sku_code}`}
          </Link>
          <H3Text text={`${record[key]?.product_sku_info?.ref_product_code ? `${record[key]?.product_sku_info?.ref_product_code} - ` : ''}${record[key]?.product_sku_info?.product_sku_name}`?.trim()} className="" />
        </div>
      );
    }

    if (record[key]?.hasOwnProperty('is_product_participant_negotiation')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.counter_price || record[key]?.price || 0)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_counter_total || record[key]?.negotiation_total)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_taxes_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_tax_counter_total || record[key]?.negotiation_tax_total)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_other_charges_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{record[key]?.other_charges?.length ? renderOtherCharges(record[key]?.other_charges) : '-'}</div>;
    }

    if (record[key]?.hasOwnProperty('is_grand_total_column')) {
      return <div style={{ display: 'flex', justifyContent: 'center' }}>{MONEY(record[key]?.negotiation_grand_counter_total || record[key]?.negotiation_grand_total)}</div>;
    }

    if (record[key]?.hasOwnProperty('is_negotiation_decision_column')) {
      return (
        <Fragment>
          <div className="participants-negotiation__wrapper">
            <div className="participants-negotiation__footer-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
              <Fragment>
                {(record[key]?.rfq_status === 'ACCEPTED') && (
                  <div>
                    <div className="participant-bid-button-shortlisted" style={{ width: '184px', margin: '1px' }}>
                      <FontAwesomeIcon icon={faCheckCircle} />
                      &nbsp;
                      Shortlisted
                    </div>
                  </div>
                )}
              </Fragment>
            </div>
          </div>
        </Fragment>
      );
    }
    return null;
  };

  const getRecordData = (record, key) => {
    if (!record[key] || typeof record[key] !== 'object') {
      return (
        <Fragment>
          <div style={{
            fontSize: '13px',
            fontWeight: '500',
          }}
          >
            {record[key] !== 'Negotiation' ? record[key] : ' '}
          </div>
        </Fragment>
      );
    }

    if (record[key].hasOwnProperty('product_sku_name')) {
      const productName = `${record[key]?.product_sku_info?.ref_product_code ? `${record[key]?.product_sku_info?.ref_product_code} - ` : ''}${record[key]?.product_sku_info?.product_sku_name}`?.trim();
      return (
        <Fragment>
          <Tooltip title={productName}>
            <div style={{ width: '250px' }}>
              <Link to={`/inventory/product/view/${record[key]?.product_sku_info?.product_sku_id}`} target="_blank">
                {`#${record[key]?.product_sku_info?.internal_sku_code}`}
              </Link>
              <H3Text text={productName} className="rfq-comparator__prod-name" />
            </div>
          </Tooltip>
        </Fragment>
      );
    }

    return null;
  };

  const getColumns = () => {
    const columns = [];

    columnKeys.forEach((key) => {
      const obj = {
        title: (
          <Tooltip title={data?.[0][key]?.participant_name}>
            {data?.[0][key]?.participant_name && (
              <div
                className="participant-name__wrapper"
                onClick={() => {
                  setRfqParticipant(data?.[0][key]);
                  setOpenPastNegotiationModal(true);
                }}
              >
                <H3Text text={data?.[0][key]?.participant_name} className="participant-name" />
                <FontAwesomeIcon icon={faSquareArrowUpRight} style={{ color: '#2D7DF7', cursor: 'pointer' }} />
              </div>
            )}
          </Tooltip>
        ),
        fixed: 'left',
        width: '200px',
        render: (record) => (
          <Fragment>
            {getRecordData(record, key)}
          </Fragment>
        ),
      };

      columns.push(obj);
      if (data?.[0][key] !== '') {
        if (data?.[1][key]?.uom_info) {
          obj.width = 'auto';
          obj.title = '';
          obj.render = (record) => (
            <div className="participant-item-tax">
              <div>
                {record?.[key]?.quantity ? `${record?.[key]?.quantity} ${record?.[key]?.uom_info?.uqc?.toProperCase()}` : ''}
              </div>
              {record?.column_name?.tax_info?.tax_value >= 0 ? <H3Text text={`+ tax @${record?.column_name?.tax_info?.tax_value}%`} className="danger-subtext" /> : ''}
            </div>
          );
        } else if (data?.[1][key]?.rfq_line_status === 'ACCEPTED') {
          obj.fixed = null;
          obj.render = (record) => (
            <Fragment>
              <div className={record?.column_name === 'Negotiation' ? 'rfq-comparator__actions' : ''}>
                {getConfirmedOfferRecordData(record, key)}
              </div>
            </Fragment>
          );
        } else {
          obj.children = [
            {
              title: <div style={{ display: 'flex', justifyContent: 'center' }}>Vendor Offer</div>,
              width: '120px',
              render: (record) => (
                <div className={record?.column_name === 'Negotiation' ? 'rfq-comparator__actions' : ''}>
                  {getVendorOfferRecordData(record, key)}
                </div>
              ),
            },
            {
              title: <div style={{ display: 'flex', justifyContent: 'center' }}>Counter Offer</div>,
              width: '120px',
              render: (record) => (
                <div className={record?.column_name === 'Negotiation' ? 'rfq-comparator__actions' : ''}>
                  {getCounterOfferRecordData(record, key)}
                </div>
              ),
            },
          ];
        }
      } else {
        obj.render = (record) => (
          <Fragment>
            {getRecordData(record, key)}
          </Fragment>
        );
      }
    });

    return columns;
  };

  const getDataSource = () => {
    const copyData = JSON.parse(JSON.stringify(selectedRfq?.group_by_products_comparator?.filter((i) => i?.column_name !== 'Other Charges')));

    return copyData.slice(1) || [];
  };

  return (
    <Fragment>
      <div className="participants__wrapper">
        <Table
          bordered
          loading={revokeCounterLoading || addCounterNegotiationLoading || acceptRfqLoading}
          showHeader
          size="small"
          scroll={{ x: true }}
          columns={getColumns()}
          dataSource={getDataSource()}
          pagination={false}
        />
        <Drawer
          open={showCounterOfferDrawer}
          width="490px"
          mask
          onClose={() => setShowCounterOfferDrawer(false)}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '440px' }}>
              <H3Text text="Counter Vendor Offer" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowCounterOfferDrawer(false)} />
            </div>
          </div>
          <div className="create-po__new-vendor-wrapper">
            <CounterVendorOfferForm
              selectedRfq={selectedRfq}
              selectedParticipant={selectedParticipant}
              callback={() => {
                callback();
                setShowCounterOfferDrawer(false);
              }}
            />
          </div>
        </Drawer>
        <Drawer
          open={openPastNegotiationModal}
          width="950px"
          mask
          onClose={() => setOpenPastNegotiationModal(false)}
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '900px' }}>
              <H3Text text={`Past Negotiations for ${rfqParticipant?.participant_name}`} className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOpenPastNegotiationModal(false)} />
            </div>
          </div>
          <div className="create-po__new-vendor-wrapper">
            <PastNegotiations
              rfqParticipant={rfqParticipant}
            />
          </div>
        </Drawer>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, RfqReducers,
}) => ({
  user: UserReducers.user,
  createRfqLoading: RfqReducers.createRfqLoading,
  updateRfqLoading: RfqReducers.updateRfqLoading,
  getRfqByIdLoading: RfqReducers.getRfqByIdLoading,
  updateRfqParticipantLoading: RfqReducers.updateRfqParticipantLoading,
  sendRfqNotificationLoading: RfqReducers.sendRfqNotificationLoading,
  revokeCounterLoading: RfqReducers.revokeCounterLoading,
  addCounterNegotiationLoading: RfqReducers.addCounterNegotiationLoading,
  acceptRfqLoading: RfqReducers.acceptRfqLoading,
  MONEY: UserReducers.MONEY,
});

const mapDispatchToProps = (dispatch) => ({
  updateRfqParticipant: (payload, callback) => dispatch(RfqActions.updateRfqParticipant(payload, callback)),
  sendRfqNotification: (payload, callback) => dispatch(RfqActions.sendRfqNotification(payload, callback)),
  getRfqById: (orgId, tenantId, rfqId, callback) => dispatch(RfqActions.getRfqById(orgId, tenantId, rfqId, callback)),
  negotiationAction: (actionType, payload, callback) => dispatch(RfqActions.negotiationAction(actionType, payload, callback)),
});

Participants.propTypes = {
  user: PropTypes.any,
  data: PropTypes.any,
  history: PropTypes.any,
  selectedRfq: PropTypes.any,
  loading: PropTypes.func,
  negotiationActionLoading: PropTypes.bool,
  negotiationAction: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Participants));
